import trtDarkcap from "../assets/bottel/trt-darkcap.png";
import enclomipheneDarkcap from "../assets/bottel/enclomiphene-darkcap.png";
import semaglutideDarkcap from "../assets/bottel/semaglutide-darkcap.png";
import tirzepatideDarkcap from "../assets/bottel/tirzepatide-darkcap.png";
import nadDarkcap from "../assets/bottel/nad-darkcap.png";
import nadNasalTransparent from "../assets/bottel/nad-nasal-transparent.png";
import sermorelinDarkcap from "../assets/bottel/sermorelin-darkcap.png";
import pt141Sapphire from "../assets/bottel/pt-141-sapphire.png";
import hairLossMenSapphire from "../assets/bottel/HairLoss_men-sapphire.png";
import hairLossWomenSapphire from "../assets/bottel/HairLoss_women-sapphire.png";
import bimatoprostTransparent from "../assets/bottel/bimatoprost-transparent.png";
import slidenafil from "../assets/bottel/slidenafil.png";
import tadalafilSapphire from "../assets/bottel/tadalafil-sapphire.png";
import blankBottleTransparent from "../assets/bottel/blank_bottle_transparent.png";
import metforminDarkcap from "../assets/bottel/metformin-darkcap.png";
import glutathione from "../assets/bottel/glutathione.png";

/** Default image when no category/name/id match is found */
export const DEFAULT_PRODUCT_IMAGE = blankBottleTransparent;

/**
 * Product ID fallbacks — used ONLY when category/name cannot uniquely determine the image.
 */
const PRODUCT_ID_IMAGE_FALLBACKS = {
  // Metformin
  68: metforminDarkcap,
  215: metforminDarkcap,
  216: metforminDarkcap,
  217: metforminDarkcap,
  // Glutathione
  218: glutathione,
  219: glutathione,
  220: glutathione,
  221: glutathione,
  // Semaglutide
  2: semaglutideDarkcap,
  47: semaglutideDarkcap,
  35: semaglutideDarkcap,
  41: semaglutideDarkcap,
  // Tirzepatide
  7: tirzepatideDarkcap,
  54: tirzepatideDarkcap,
  22: tirzepatideDarkcap,
  28: tirzepatideDarkcap,
  // NAD+ Nasal
  225: nadNasalTransparent,
  226: nadNasalTransparent,
  227: nadNasalTransparent,
  228: nadNasalTransparent,
  // Sermorelin
  66: sermorelinDarkcap,
  67: sermorelinDarkcap,
  // Men's Hair Loss
  175: hairLossMenSapphire,
  176: hairLossMenSapphire,
  177: hairLossMenSapphire,
  // Women's Hair Loss
  178: hairLossWomenSapphire,
  179: hairLossWomenSapphire,
  180: hairLossWomenSapphire,
  // Sildenafil (ED)
  90: slidenafil,
  94: slidenafil,
  77: slidenafil,
  78: slidenafil,
  80: slidenafil,
  83: slidenafil,
  84: slidenafil,
  85: slidenafil,
  86: slidenafil,
  88: slidenafil,
  87: slidenafil,
  89: slidenafil,
  91: slidenafil,
  92: slidenafil,
  95: slidenafil,
  93: slidenafil,
  96: slidenafil,
  79: slidenafil,
  81: slidenafil,
  82: slidenafil,
  110: slidenafil,
  114: slidenafil,
  97: slidenafil,
  98: slidenafil,
  100: slidenafil,
  103: slidenafil,
  104: slidenafil,
  105: slidenafil,
  106: slidenafil,
  108: slidenafil,
  107: slidenafil,
  109: slidenafil,
  111: slidenafil,
  112: slidenafil,
  115: slidenafil,
  113: slidenafil,
  116: slidenafil,
  99: slidenafil,
  101: slidenafil,
  102: slidenafil,
  // Tadalafil (ED)
  130: tadalafilSapphire,
  134: tadalafilSapphire,
  117: tadalafilSapphire,
  118: tadalafilSapphire,
  120: tadalafilSapphire,
  123: tadalafilSapphire,
  124: tadalafilSapphire,
  125: tadalafilSapphire,
  126: tadalafilSapphire,
  128: tadalafilSapphire,
  127: tadalafilSapphire,
  129: tadalafilSapphire,
  131: tadalafilSapphire,
  132: tadalafilSapphire,
  135: tadalafilSapphire,
  133: tadalafilSapphire,
  136: tadalafilSapphire,
  119: tadalafilSapphire,
  121: tadalafilSapphire,
  122: tadalafilSapphire,
  154: tadalafilSapphire,
  158: tadalafilSapphire,
  141: tadalafilSapphire,
  142: tadalafilSapphire,
  144: tadalafilSapphire,
  147: tadalafilSapphire,
  148: tadalafilSapphire,
  149: tadalafilSapphire,
  150: tadalafilSapphire,
  152: tadalafilSapphire,
  151: tadalafilSapphire,
  153: tadalafilSapphire,
  155: tadalafilSapphire,
  156: tadalafilSapphire,
  159: tadalafilSapphire,
  157: tadalafilSapphire,
  160: tadalafilSapphire,
  143: tadalafilSapphire,
  145: tadalafilSapphire,
  146: tadalafilSapphire,
  138: tadalafilSapphire,
  140: tadalafilSapphire,
  137: tadalafilSapphire,
  139: tadalafilSapphire,
  162: tadalafilSapphire,
  164: tadalafilSapphire,
  161: tadalafilSapphire,
  163: tadalafilSapphire,
};

const normalizeText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[+]/g, " plus ")
    .replace(/[_/\\|-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/**
 * Build a searchable haystack from category/type/name fields.
 * Prefer category fields; include product name for type-level matching
 * (e.g. Semaglutide vs Tirzepatide within "Weight Loss").
 */
const getProductSearchText = (product = {}) => {
  const parts = [
    product.product_category_name,
    product.product_category,
    product.category,
    product.product_type,
    product.vertical_name,
    product.product_name,
    product.product_description,
  ];
  return normalizeText(parts.filter(Boolean).join(" "));
};

const includesAny = (text, terms) => terms.some((term) => text.includes(term));

/**
 * Category / name based rules (order matters for overlapping keywords).
 * Matching is case-insensitive and tolerant of minor naming differences.
 */
const CATEGORY_IMAGE_RULES = [
  // NAD+ Nasal before generic NAD
  {
    image: nadNasalTransparent,
    match: (text) =>
      includesAny(text, [
        "nad nasal",
        "nad plus nasal",
        "nasal nad",
        "nasal spray",
      ]) && includesAny(text, ["nad", "nad plus"]),
  },
  // Oral TRT / Enclomiphene before injectable TRT
  {
    image: enclomipheneDarkcap,
    match: (text) =>
      includesAny(text, [
        "oral trt",
        "enclomiphene",
        "testosterone oral",
        "oral testosterone",
      ]),
  },
  // Injectable TRT / Testosterone Replacement
  {
    image: trtDarkcap,
    match: (text) =>
      includesAny(text, [
        "injectable trt",
        "trt injection",
        "testosterone cypionate",
        "testosterone replacement",
        "testosterone replacement therapy",
      ]) ||
      (/\btrt\b/.test(text) &&
        !includesAny(text, ["enclomiphene", "oral trt", "oral testosterone"])),
  },
  // Semaglutide
  {
    image: semaglutideDarkcap,
    match: (text) =>
      includesAny(text, ["semaglutide"]) || /\bsema\b/.test(text),
  },
  // Tirzepatide
  {
    image: tirzepatideDarkcap,
    match: (text) =>
      includesAny(text, ["tirzepatide"]) || /\btirz\b/.test(text),
  },
  // NAD+ Injectable
  {
    image: nadDarkcap,
    match: (text) =>
      includesAny(text, [
        "nad injectable",
        "nad injection",
        "injectable nad",
        "nad plus injectable",
        "nad plus injection",
      ]) ||
      (includesAny(text, ["nad", "nad plus"]) &&
        includesAny(text, ["inject", "injection"]) &&
        !includesAny(text, ["nasal"])),
  },
  // Sermorelin
  {
    image: sermorelinDarkcap,
    match: (text) => includesAny(text, ["sermorelin"]),
  },
  // PT-141
  {
    image: pt141Sapphire,
    match: (text) =>
      includesAny(text, ["pt 141", "pt-141", "pt141", "bremelanotide"]),
  },
  // Women's Hair Loss (before men's — "women" contains the substring "men")
  {
    image: hairLossWomenSapphire,
    match: (text) =>
      includesAny(text, [
        "women's hair loss",
        "womens hair loss",
        "hair loss women",
        "hair loss - women",
        "female hair loss",
        "spironolactone",
        "minoxidil",
      ]) ||
      (includesAny(text, ["hair loss"]) &&
        /\b(women|woman|female|womens)\b/.test(text)),
  },
  // Men's Hair Loss
  {
    image: hairLossMenSapphire,
    match: (text) =>
      includesAny(text, [
        "men's hair loss",
        "mens hair loss",
        "hair loss men",
        "hair loss - men",
        "male hair loss",
        "finasteride",
      ]) ||
      (includesAny(text, ["hair loss"]) &&
        /\b(men|man|male|mans|mens)\b/.test(text) &&
        !/\b(women|woman|female|womens)\b/.test(text)),
  },
  // Eyelash Treatment / Bimatoprost / Latisse
  {
    image: bimatoprostTransparent,
    match: (text) =>
      includesAny(text, [
        "eyelash",
        "bimatoprost",
        "latisse",
        "lash growth",
      ]),
  },
  // Sildenafil (ED)
  {
    image: slidenafil,
    match: (text) =>
      includesAny(text, ["sildenafil", "viagra", "ed sildenafil"]),
  },
  // Tadalafil (ED)
  {
    image: tadalafilSapphire,
    match: (text) =>
      includesAny(text, ["tadalafil", "cialis", "ed tadalafil"]),
  },
];

/**
 * Resolve the checkout product image.
 * Primary: product category / type / name (case-insensitive, fuzzy).
 * Fallback: product ID map when category alone cannot uniquely determine.
 * Default: blank_bottle_transparent.png
 *
 * @param {object|string|number} productOrId - Product object or product ID
 * @returns {string} Image URL/module path
 */
export const getProductImage = (productOrId) => {
  if (productOrId == null) {
    return DEFAULT_PRODUCT_IMAGE;
  }

  const product =
    typeof productOrId === "object"
      ? productOrId
      : { product_id: productOrId };

  const searchText = getProductSearchText(product);

  if (searchText) {
    for (const rule of CATEGORY_IMAGE_RULES) {
      if (rule.match(searchText)) {
        return rule.image;
      }
    }
  }

  const rawId = product.product_id ?? product.id ?? productOrId;
  const numericId = Number(rawId);
  if (!Number.isNaN(numericId) && PRODUCT_ID_IMAGE_FALLBACKS[numericId]) {
    return PRODUCT_ID_IMAGE_FALLBACKS[numericId];
  }

  return DEFAULT_PRODUCT_IMAGE;
};

export default getProductImage;
